module.exports = __webpack_public_path__ + "img/CH.c583f16a.svg";